import * as columnsModules from "@/assets/mock/columns";

export default class PolicyColumns {

    constructor() {}

    static get(options) {
        const {
			reportKey
        } = options;
        return columnsModules[reportKey];
    }

}